import { render, staticRenderFns } from "./IntervencionActivaListComponent.vue?vue&type=template&id=6e2f64c9"
import script from "./IntervencionActivaListComponent.vue?vue&type=script&lang=js"
export * from "./IntervencionActivaListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports